import { Injectable } from '@angular/core';

@Injectable()
export class AnonymizeProvider {

  /**
   * Anonymizes a name according to LGPD requirements
   * Pattern: first three letters + 16 asterisks + last two letters
   * Example: "Matheus Vinicius" becomes "Mat****************us"
   *
   * @param name The name to anonymize
   * @returns The anonymized name
   */
  anonymizeName(name: string): string {
    if (!name) {
      return '';
    }

    // If name is shorter than 5 characters, we can't apply the pattern properly
    if (name.length < 5) {
      return '*'.repeat(name.length);
    }

    const firstThree = name.substring(0, 3);
    const lastTwo = name.substring(name.length - 2);
    const asterisks = '*'.repeat(16);

    return `${firstThree}${asterisks}${lastTwo}`;
  }
}



// WEBPACK FOOTER //
// ./src/providers/anonymize/anonymize.provider.ts